import { ReactNode } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { IFlashMessage } from '@jetslash/market-frontend-shared-core/src/types/flashMessage';

export function generateFlashMessage(
  type: 'success' | 'info' | 'warning' | 'error' | 'danger',
  message: string | ReactNode,
): IFlashMessage {
  return {
    uuid: uuidv4(),
    type,
    message,
  };
}
